import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _CommercialCampaign, _DistributionChannel, _FreightRate, _TransportDestination, _UBLPaymentMeans } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const UBLPaymentMeansEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_UBLPaymentMeans)
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const [text, setText] = useState<string>("");

    const modal = useModal("Formas de Pago", MODAL_md);

    useEffect(() => {
        if (render) {
            console.log(render)
            setText(render)
        }
    }, [render])

    useEffect(() => {
        if (idSelector) {
            instance.getUBLPaymentMeans(idSelector).then(
                (resp) => {
                    console.log(resp)
                    onChange(returnType === "Object" ? resp : resp?.IDUBLPaymentMeans)
                    setText(resp?.Description)
                }
            ).catch(err => { console.log(err) })
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDUBLPaymentMeans == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                if (selectedItem.DataBeanProperties.IDUBLPaymentMeans) {
                    setText(selectedItem.DataBeanProperties.Description)
                }
                modal.close();
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getUBLPaymentMeansCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)


                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDUBLPaymentMeans', visible: true },
        { title: 'Código', property: 'PaymentMeansID', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Habiltado', property: 'IsEnabled', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Formas de Pago"}</label>
            <span className='form-control cursor ifmodal' onClick={() => { modal.open() }}>{ text ?? "Seleccione una forma de pago"}</span>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDUBLPaymentMeans); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}